"use client";

import * as React from "react";

import { BookingBranchLocationPicker } from "@/components/booking/BookingBranchLocationPicker";

export {
  bookingLocationTriggerClassName,
} from "@/components/booking/BookingBranchLocationPicker";

export type BookingLocationSelectProps = {
  value?: string;
  defaultValue?: string;
  onValueChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
  id?: string;
};

export function BookingLocationSelect({
  value,
  defaultValue,
  onValueChange,
  placeholder = "Choose branch...",
  className,
  id,
}: BookingLocationSelectProps) {
  const [internalValue, setInternalValue] = React.useState(defaultValue ?? "");
  const isControlled = value !== undefined;
  const selectedValue = isControlled ? value : internalValue;

  const handleValueChange = (next: string) => {
    if (!isControlled) {
      setInternalValue(next);
    }
    onValueChange?.(next);
  };

  return (
    <BookingBranchLocationPicker
      id={id}
      mode="pickup"
      value={selectedValue}
      onValueChange={handleValueChange}
      placeholder={placeholder}
      emptyDetailMessage="Select a pickup branch to see details."
      className={className}
    />
  );
}
